var _style, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _g, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _g2, _path78, _g3, _path79, _g4, _g5, _g6, _g7, _g8, _g9, _g10;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPilotPlus(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 421 587",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", null, "\n    .st0{fill:#1974CE;}\n\t.st1{fill:#F9F6EE;}\n\t.st2{fill:#54A895;}\n\t.st3{fill:#84EDFB;}\n\t.st4{fill:#8F91DA;}\n\t.st5{fill:#B4CB61;}\n\t.st6{fill:#1A4359;}\n\t.st7{fill:#537282;}\n\t.st8{opacity:0.75;}\n\t.st9{opacity:0.5;fill:#1A4359;}\n\t.st10{opacity:0.4;fill:#1A4359;}\n\t.st11{fill:#FFFFFF;}\n\t.st12{fill:#939598;}\n  ")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m407.9 459-.3-126.8-111.8-65.4.7-127.8-122.6-70.3L147 83.3v87.6l-8.6 5-63.1-36.2-56.8 30.9v127.1l117.8 69 19.6-10 .3 68.4-27.9 16.9v50.1l111.2 64.1 56.8-30.5-.3-67.4 54.8 31.9 57.1-31.2zM183.6 202.1l47.1-26.2v80.7l-17.9-10.3v-27.9l-29.2-16.3zm30.2-69.3-32.5 18.6-.3-37.5 32.8 18.9zm-21.6 322.6 38.5-21.9.3 43.8-38.8-21.9zm68-59.4-26.6-14.6-40.2 23.2v-79L84 263.5v-44.8l34.5 19.2L148 222l28.5 15.6v27.9l27.5 16.3v27.5l27.9 16.6v27.2l28.2 16.3V396zm82 15.9-45.5-26.2.3-36.2-27.9-15.6-.3-9 73.3 43.1v43.9z",
    className: "st0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m407.9 459-.3-126.8-111.8-65.4.7-127.8-122.6-70.3L147 83.3v87.8l-8.6 4.8-63.1-36.2-56.8 30.9v127.1l117.8 69 19.6-10 .3 68.4-27.9 16.9v50.1l111.2 64.1 56.8-30.5-.3-67.4 54.8 31.9 57.1-31.2zM183.6 202.1l47.1-26.2v80.7l-17.9-10.3v-27.9l-29.2-16.3zm30.2-69.3-32.5 18.6-.3-37.5 32.8 18.9zm-21.6 322.6 38.5-21.9.3 43.8-38.8-21.9zm68-59.4-26.6-14.6-40.2 23.2v-79L84 263.5v-44.8l34.5 19.2L148 222l28.5 15.6v27.9l27.5 16.3v27.5l27.9 16.6v27.2l28.2 16.3V396zm82 15.9-45.5-26.2.3-36.2-27.9-15.6-.3-9 73.3 43.1v43.9z",
    className: "st0"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m296.9 267.1-57 31 111.6 65 56.1-30.9z",
    className: "st1"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "m296.9 267.1-57 31-.2-128.3 56.6-30.7z",
    className: "st2"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "m84.4 262.5-56.6 31 109.4 63 56-30.9z",
    className: "st3"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M342.6 412.2 297 385.6l-27.7 15-36-19.7-26.6 16 135.9 78.6z",
    className: "st4"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "m75.4 139.7-56.8 30.9 91.2 52.1v-30.3l28.6-16.5z",
    className: "st5"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M36 180.4 56.2 192v-41.5L36 161.6z",
    className: "st1"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "m68.3 144.1-5.3 2.8v49.7l5.3 2.9z",
    className: "st1"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "m174.4 68.1-27 14.7c-.6.4-.7 1.3 0 1.6l76.3 43-28.8 16.3 45.1 26.6 56.3-31.3-121.9-70.9z",
    className: "st5"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M297.5 58.9V14.1c-31.2-8.9-45.7 12.1-71.8 2.8v44.7c26.1 9.4 40.5-11.6 71.8-2.7z",
    className: "st3"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "m155.6 99.3 58.7 33.3 9.3-5.2L147 83.9v87.2l8.6-4.9z",
    className: "st1"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "m27.3 185.6 91 52.1-7.7-14.4-91.9-52.6v127.9l118.1 68.3-.4-9.9-109.9-63.6z",
    className: "st1"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "m109.9 228.5-.1-36.1 28.6 15.9v-32.4l28.4 16.5.3-32 27.8 16.2-.1-33 45.1 26.6v127.9l111.6 65v127.1l-112.3-64.9v131l-110.7-64.1v-50.1l25.7 14.9v-29.7l26.2 14.5v-29.7l26.4 14.8v-29.4l42.4 24.2-2.4 7.6-15.8-8.6-15.9-9v30.1l-26.5-15.2v29.8l-25.4-14.9v30.1l-26.5-15.2v30.7l94.3 54.3V410.7l8.2 5.3 16.2 9.3 87.2 50.2V367.7l-111-64.5V175.9L203.2 159v31.5l-28.5-15.6v31.4l-28.1-15.8v31.6l-28.4-16.4.1 32z",
    className: "st1"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "m138.7 176.3-28.2 16.1 28.2 16.2v-32.3",
    className: "st5"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "m167.5 160-28.2 16.1 28.2 16.3V160",
    className: "st5"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "m195.1 144.1-28.2 16.1 28.2 16.2v-32.3",
    className: "st5"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "m154.2 427.3-26.3 14.4 26.5 15.3-.2-29.7",
    className: "st4"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "m180.6 411.7-25.7 15.2 25.2 14.6-.2-29.7",
    className: "st4"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M207 396.9 181.3 412l25.2 14.6-.2-29.6",
    className: "st4"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "m183.6 202.1-26.8 14.7 27.9 15.7 28.1-14.1z",
    className: "st2"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "m212.4 245.5-26.7 14.6-1-27.6 28.1-14.1z",
    className: "st2"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "m231.3 294.6-17.3 9.6-1-27.6 18.6-9.1z",
    className: "st2"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "m230.8 294.8-17.5 9.6 28.6 16 9.1-5.6-19.7-11.9z",
    className: "st2"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "m268.8 333.8-27.3 14.9.4-28.3 9.4-5.3 17.7 9.8z",
    className: "st2"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "m268.8 333.8-27.7 14.7 27.9 15.7 28.1-14.4z",
    className: "st2"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "m296.9 385.2-27.6 14.7-.3-35.7 28.1-14.4z",
    className: "st2"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "m231.3 256.2-19.4-10.7-26.7 14.6 27.8 15.7 18.3-9.1z",
    className: "st2"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "m156.5 356.6-.5 68.6 8.9-4.5v-68.5z",
    className: "st1"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "m156.8 216.8 27.9 15.7v27.9l28.3 15.4v29l28.9 15.6v28.1l27.1 15.7v35.7l-8.8-3.9v-26.6L232 353.2v-27.3l-27.9-16.6v-27.9l-27.5-15.9v-27.8L148 222.1z",
    className: "st1"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "m137.4 176.4-24.8 14.1-30.9-17.8 25.8-14.3-.4-.7-26.3 14.4-31.2-18-.5.8 30.8 17.8-29.6 16.1 1.2.5 29.3-16.1 30.9 17.8L83 207.4l.9.5 53.9-30.7z",
    className: "st6"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "m381.8 346.1-31.2-18 25.9-14.2-.5-.8-26.3 14.4-29.2-16.9 26-14.3-.4-.8-26.5 14.6-29.2-16.9 26-14.3-.4-.8-26.6 14.6-19.6-11.4-.5.8 19.2 11.1-29 15.9.4.8 29.5-16.2 29.2 16.9-29 16 .4.8 29.5-16.2 29.3 16.8-29.2 16.1.4.8 29.7-16.3 31.7 18.3z",
    className: "st7"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "st8"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m297 350.1-27.7 14.6.3 36.4 54.6-.1-27.2-15.5z",
    className: "st9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M268.1 325.5 250.2 315l-9.8 5.2.3 28.5 54.6-.1-27.2-15.5z",
    className: "st9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m231.1 255.8-18.6-10.6v-26.9l-16.4 8.6-11.3 5.4.3 28.5 46-.1z",
    className: "st9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M231.1 267.1h-.7l-17.3 9.1.3 28.4h20.1l-2.3-1.3z",
    className: "st9"
  }))), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "m296.1 267.4-56.5 30.8.3-.1h109.3l-53.5-31.2z",
    className: "st9"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M139.3 294.4 84.4 263l-56.9 30.6v.8z",
    className: "st9"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M297.1 458.9 239.6 426l-.2 130.5 57.1-30.7z",
    className: "st6"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M118.3 237.8v-31.6l28.3 15.8v-31.2l28.3 15.8v-31.2l28.2 15.4v-31.6L231 175z",
    className: "st10"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "m231.4 477.3-38-22.1 37.3-21.8.5-12.1-16.2-9.1v29.3l-26-14.1v28.9l-26-14.5-.3 29.7-25.5-14.8-.2 30.5h94.4z",
    className: "st10"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "m166.5 104.9-10.2-5.7.3 66.4 24.6-14v-37.9z",
    className: "st0"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M242.6 108.2H226l-2.3 4H250z",
    className: "st9"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "m110.4 192.3 84.6-48.6",
    className: "st11"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M103.9 167.4h97.7v1.3h-97.7z",
    transform: "rotate(-29.865 152.71910463 167.99236365)"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M156.4 166.5h-1.3V98.7c0-.2.1-.4.3-.5.2-.1.4-.1.6 0l58.7 34-.6 1.1-57.7-33.5v66.7z"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M194.3 404.4H193v-78.2L83.7 263.1c-.2-.1-.3-.3-.3-.5v-44.2h1.3v43.9l109.3 63c.2.1.3.3.3.5v78.6z"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M319.1 372.2h1.3v52.9h-1.3z",
    transform: "rotate(-60.058 319.6863579 398.60911494)"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M180.4 113.4h1.3v38h-1.3z"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "m138.3 176.8-62.8-36.3-56.4 30.8-.6-1.1 57-31.2.3.2 63.1 36.5z"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "m239.2 170.2 56.8-31",
    className: "st12"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M235.3 154.3H300v1h-64.7z",
    transform: "rotate(-28.634 267.61752411 154.74065776)"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "m239.6 298.2 56.4-30.8",
    className: "st12"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M235.6 282.3h64.3v1h-64.3z",
    transform: "rotate(-28.7 267.7915426 282.82135635)"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "m350.6 363.6 56.7-31",
    className: "st12"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M346.6 347.6h64.7v1h-64.7z",
    transform: "rotate(-28.634 378.94881114 348.0779207)"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "m351.3 490.4 56.7-31.1",
    className: "st12"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M347.3 474.2H412v1.3h-64.7z",
    transform: "matrix(.8774 -.4797 .4797 .8774 -181.264 240.3403)"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "m240.1 557.1-.6-1.1 55.2-30.2c.4-.2.8-.4 1.1-.6V459h1.3v66.7c0 .3-.1.5-.4.6 0 0-.8.3-1.4.7l-55.2 30.1z"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "m137 357.1 56.8-31",
    className: "st12"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M133.1 341.1h64.7v1h-64.7z",
    transform: "matrix(.8774 -.4797 .4797 .8774 -143.5789 121.2108)"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M269.3 401.4c-.1 0-.2 0-.3-.1l-8.7-4.8c-.2-.1-.3-.3-.3-.6v-26.1l-27.7-16c-.2-.1-.3-.3-.3-.5V326l-27.7-16c-.2-.1-.3-.3-.3-.5v-27.3l-27.7-16c-.2-.1-.3-.3-.3-.5v-27.3l-27.7-16c-.2-.1-.3-.3-.3-.6 0-.2.1-.4.3-.5l8.6-4.8c.2-.1.4-.1.6 0l28.1 15.9c.2.1.3.3.3.6v27.3l27.7 16c.2.1.3.3.3.5V304l27.7 16c.2.1.3.3.3.5v27.3l27.7 16c.2.1.3.3.3.5v36.3c0 .2-.1.4-.3.5-.1.2-.2.3-.3.3zm-8.1-5.8 7.5 4.1v-34.8l-27.7-16c-.2-.1-.3-.3-.3-.5v-27.3l-27.7-16c-.2-.1-.3-.3-.3-.5V277L185 261c-.2-.1-.3-.3-.3-.5v-27.3L157 217.6l-7.3 4.1 27.1 15.6c.2.1.3.3.3.5v27.3l27.7 16c.2.1.3.3.3.5V309l27.7 16c.2.1.3.3.3.5v27.3l27.7 16c.2.1.3.3.3.5v26.3z"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M239.7 557.2c-.1 0-.2 0-.3-.1l-111.2-64.2c-.2-.1-.3-.3-.3-.5v-50.8h1.3V492l110 63.5V426c0-.2.1-.4.3-.5.2-.1.4-.1.6 0l110.6 63.9V363.1l-111.2-64.2c-.2-.1-.3-.3-.3-.5v-128l-44-25.5.6-1.1 44.4 25.7c.2.1.3.3.3.5v128l111.2 64.2c.2.1.3.3.3.5v127.7c0 .2-.1.4-.3.5-.2.1-.4.1-.6 0L240.5 427v129.5c0 .2-.1.4-.3.5-.3.2-.4.2-.5.2z"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M154.4 457.6c-.1 0-.2 0-.3-.1L128 442.4l.6-1.1 25.2 14.5V427c0-.2.1-.4.3-.5.2-.1.4-.1.6 0l25.2 14.5v-28.9c0-.2.1-.4.3-.5.2-.1.4-.1.6 0l25.2 14.5v-28.9c0-.2.1-.4.3-.5.2-.1.4-.1.6 0l49.2 28.4-.6 1.1-48.3-27.9v28.9c0 .2-.1.4-.3.5-.2.1-.4.1-.6 0l-25.2-14.5v28.9c0 .2-.1.4-.3.5-.2.1-.4.1-.6 0L155 428.1V457c0 .2-.1.4-.3.5-.1.1-.2.1-.3.1z"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M231.2 542.4c-.1 0-.2 0-.3-.1l-94.3-54.5c-.2-.1-.3-.3-.3-.5v-30.7c0-.2.1-.4.3-.5.2-.1.4-.1.6 0l25.2 14.5v-28.9c0-.2.1-.4.3-.5.2-.1.4-.1.6 0l25.2 14.5v-28.9c0-.2.1-.4.3-.5.2-.1.4-.1.6 0l25.2 14.5V412c0-.2.1-.4.3-.5.2-.1.4-.1.6 0l12.6 7.2 3.4 2.1c.2.1.3.3.3.5v120.5c0 .2-.1.4-.3.5-.1.1-.2.1-.3.1zm-93.7-55.5 93 53.7v-119l-3.1-1.9-11.6-6.7v28.9c0 .2-.1.4-.3.5-.2.1-.4.1-.6 0L189.7 428v28.9c0 .2-.1.4-.3.5-.2.1-.4.1-.6 0l-25.2-14.5v28.9c0 .2-.1.4-.3.5-.2.1-.4.1-.6 0l-25.2-14.5v29.1z"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M342.7 476.3c-.1 0-.2 0-.3-.1l-111.6-64.4.6-1.1L342 474.6V368l-111.2-64.2c-.2-.1-.3-.3-.3-.5V175.4l-26.8-15.5v30.8c0 .2-.1.4-.3.5-.2.1-.4.1-.6 0L175.5 176v30.6c0 .2-.1.4-.3.5s-.4.1-.6 0l-27.3-15.6V222c0 .2-.1.4-.3.5-.2.1-.4.1-.6 0l-27.3-15.6v30.9c0 .2-.1.4-.3.5-.2.1-.4.1-.6 0l-90.3-52v106.5l109.4 63.1c.2.1.3.3.3.5V367h-1.3v-9.8L27 294.1c-.2-.1-.3-.3-.3-.5v-108c0-.2.1-.4.3-.5.2-.1.4-.1.6 0l90.3 52V206c0-.2.1-.4.3-.5.2-.1.4-.1.6 0l27.3 15.6v-30.5c0-.2.1-.4.3-.5.2-.1.4-.1.6 0l27.3 15.6V175c0-.2.1-.4.3-.5.2-.1.4-.1.6 0l27.3 15.2v-30.9c0-.2.1-.4.3-.5.2-.1.4-.1.6 0l28 16.2c.2.1.3.3.3.5v127.9L343 367.1c.2.1.3.3.3.5v108c0 .2-.1.4-.3.5-.1.1-.2.2-.3.2z"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M155.8 357h1.3v68.7h-1.3z"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M408.6 459.4h-1.3V332.1l-111.2-64.2c-.2-.1-.3-.3-.3-.5v-128L174.2 69l-26.3 14.5v87.6h-1.3V83.2c0-.2.1-.4.3-.6l27-14.9c.2-.1.4-.1.6 0l122.2 70.7c.2.1.3.3.3.5v127.9L408.2 331c.2.1.3.3.3.5v127.9z"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "m194.8 144.6-.7-1.1 27.5-15.9L147 84.3l.6-1.1 76.5 44.4z"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "m118.7 238.1 112.1-62.7",
    className: "st11"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M110.5 206.1H239v1.3H110.5z",
    transform: "matrix(.873 -.4878 .4878 .873 -78.6257 111.4918)"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M23.3 277.7H88v1H23.3z",
    transform: "matrix(.8774 -.4797 .4797 .8774 -126.6077 60.7891)"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "m269.2 400.8 28.2-15.5",
    className: "st12"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M267.2 392.6h32.2v1h-32.2z",
    transform: "rotate(-28.7 283.29546618 393.04611577)"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "m129.2 442.2-.6-1.1 104.9-60.6c.2-.1.5-.1.8.1l.6.6 28.6 15.6-.6 1.1-28.6-15.7-.1-.1-.4-.3-104.6 60.4z"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M165.5 421.1h-1.3v-68l-27 14.8c-.2.1-.4.1-.6 0L18.4 299c-.2-.1-.3-.3-.3-.5V170.8c0-.2.1-.4.3-.5.2-.1.4-.1.6 0l90.7 52.2v-30.1c0-.2.1-.4.3-.5.2-.1.4-.1.6 0l27.2 15.7v-31.3c0-.2.1-.4.3-.5s.4-.1.6 0l27.2 15.7v-31.3c0-.2.1-.4.3-.5s.4-.1.6 0l27.2 15.7v-31.3h1.3v32.4c0 .2-.1.4-.3.5s-.4.1-.6 0l-27.2-15.7v31.3c0 .2-.1.4-.3.5s-.4.1-.6 0l-27.2-15.7v31.3c0 .2-.1.4-.3.5s-.4.1-.6 0L111 193.5v30.1c0 .2-.1.4-.3.5-.2.1-.4.1-.6 0l-90.7-52.2v126.2L137 366.6l27.6-15.1c.2-.1.4-.1.6 0 .2.1.3.3.3.5v69.1z"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "m137 487.4 93.8-54.2",
    className: "st11"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M129.7 459.7H238v1.3H129.7z",
    transform: "rotate(-29.991 183.90233385 460.32130927)"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M297.5 386.2h-1.3v-35.9l-27.7-16c-.2-.1-.3-.3-.3-.5v-9h1.3v8.6l27.7 16c.2.1.3.3.3.5v36.3z"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "m230.6 257-18.1-10.5c-.2-.1-.3-.3-.3-.5v-27.3l-28.7-16.3.6-1.1 29 16.5c.2.1.3.3.3.6v27.3l17.8 10.3-.6 1z"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M211.1 443.8h1.3v44.5h-1.3z",
    transform: "rotate(-59.987 211.75777028 466.0969322)"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m269.2 364.4 27.6-14.4",
    className: "st12"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M267.4 356.7h31.1v1h-31.1z",
    transform: "matrix(.8849 -.4659 .4659 .8849 -133.8191 172.9606)"
  }))), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "M223.9 6.5s-5.1.6-5.1 5.1 1.9 3.9 1.9 3.9l1 1.7v93.1s.3 2 2.1 2 2.3-1.1 2.4-2.2c.1-1.1-.2-91-.2-91l.6-3.5s2.4-1.4 2.4-4.7-5.1-4.4-5.1-4.4z",
    className: "st0"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M223.9 17.3c-3.2 0-5.7-2.6-5.7-5.7s2.6-5.7 5.7-5.7c3.2 0 5.7 2.6 5.7 5.7s-2.5 5.7-5.7 5.7zm0-10.2c-2.5 0-4.5 2-4.5 4.5s2 4.5 4.5 4.5 4.5-2 4.5-4.5-2-4.5-4.5-4.5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M221.6 111.3c-.4 0-.6-.3-.6-.6V16.3c0-.4.3-.6.6-.6.4 0 .6.3.6.6v94.4c.1.3-.2.6-.6.6z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M226 111.3c-.4 0-.6-.3-.6-.6v-94c0-.4.3-.6.6-.6.4 0 .6.3.6.6v94c0 .3-.3.6-.6.6z"
  }))), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "M238.9 64.5c-5.3 0-9.9-.8-13.2-2.5l.6-1.1c8.4 4.2 24.1 2.1 35.9-1.8 16.8-5.5 30.5-2.4 34-1.5v-43c-2.6-.8-16.4-4.3-33.6 1.4-14.7 4.9-29.2 5.5-36.8 1.7l.6-1.1c8.4 4.2 24.1 2.1 35.9-1.8 19.4-6.4 34.7-1.3 34.8-1.2.3.1.4.3.4.6v44.4c0 .2-.1.4-.3.5-.2.1-.4.1-.6.1-.1-.1-15.1-5-34 1.2-8.4 2.7-16.7 4.1-23.7 4.1z"
  })), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M252.4 55.1c-.4-.1-.6-.4-.6-.8V30.5c0-.4.3-.6.6-.5.3.1.6.4.6.7v23.8c0 .4-.2.6-.6.6z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M252.4 43.3c-.3-.1-.6-.3-.6-.6-.1-.4.2-.6.5-.6 5.7 0 11.4-2.6 17.2-3.8 2.4-.5 4.4-3 4.4-6.1 0-1.6-.6-3.1-1.6-4-.7-.7-1.6-.9-2.6-.8-5.7 1.2-11.4 3.8-17.2 3.9-.3 0-.7-.3-.7-.7-.1-.4.2-.6.5-.6 5.7 0 11.4-2.6 17.2-3.8 1.3-.3 2.6.1 3.6 1.1 1.3 1.2 2 3.2 2 5.2 0 3.6-2.4 6.4-5.4 7.1-5.7 1.2-11.4 3.8-17.2 3.9 0-.2 0-.2-.1-.2z"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m241.1 348.4 27.5-14.5",
    className: "st12"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M239.3 340.7h31.1v1h-31.1z",
    transform: "matrix(.8849 -.4659 .4659 .8849 -129.5892 158.0086)"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m241.1 320.6 10.4-5.5",
    className: "st12"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M240.4 317.4h11.7v1h-11.7z",
    transform: "matrix(.8849 -.4659 .4659 .8849 -119.7108 151.3335)"
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m213.3 304.2 17.5-9.2",
    className: "st12"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.1 299.1h19.8v1h-19.8z",
    transform: "matrix(.8849 -.4659 .4659 .8849 -114.0134 137.9398)"
  }))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m213 276.7 18-9.5",
    className: "st12"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M211.8 271.3h20.4v1.3h-20.4z",
    transform: "rotate(-27.767 221.9906405 271.93651616)"
  }))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m185.1 260.4 27.6-14.5",
    className: "st12"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M183.3 252.7h31.1v1h-31.1z",
    transform: "matrix(.8847 -.4661 .4661 .8847 -95.0634 121.8908)"
  }))), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m184.8 232.8 27.6-14.4",
    className: "st12"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M183 225.1h31.1v1H183z",
    transform: "rotate(-27.782 198.6036465 225.6169705)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPilotPlus);
export default __webpack_public_path__ + "static/media/pilot-plus.7beb0efbd14c89938289be296c63002a.svg";
export { ForwardRef as ReactComponent };